module.exports = __webpack_public_path__ + "static/media/illuminate-color-pallete.a6ebf48b.png";